import { FaChevronLeft as ChevronLeft } from 'react-icons/fa'

interface TablePaginationProps {
  page: number
  maxPage: number
  onPrev: () => void
  onNext: () => void
  className?: string
}

const baseButtonClasses = 'p-2 rounded-lg transition-colors'

export function TablePagination({ page, maxPage, onPrev, onNext, className = '' }: TablePaginationProps) {
  const handlePrev = () => {
    if (page > 1) onPrev()
  }

  const handleNext = () => {
    if (page < maxPage) onNext()
  }

  const prevDisabled = page === 1
  const nextDisabled = page === maxPage

  return (
    <div className={`flex items-center justify-center gap-4 p-4 border-t border-gray-800 ${className}`.trim()}>
      <button
        onClick={handlePrev}
        disabled={prevDisabled}
        className={`${baseButtonClasses} ${
          prevDisabled ? 'text-gray-600 cursor-not-allowed' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
        }`}
        aria-label="Previous page"
        type="button"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      <span className="text-sm text-gray-400">
        Page {page} of {maxPage}
      </span>

      <button
        onClick={handleNext}
        disabled={nextDisabled}
        className={`${baseButtonClasses} ${
          nextDisabled ? 'text-gray-600 cursor-not-allowed' : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
        }`}
        aria-label="Next page"
        type="button"
      >
        <ChevronLeft className="w-5 h-5 rotate-180" />
      </button>
    </div>
  )
}

export default TablePagination
